import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import Toast from '../../../../../../components/Toast';
import { options } from '../../../../../../helpers/toastOptions';
import { useModal } from '../../../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { SearchMyCollectionsContext } from '../..';
import api from '../../../../../../services/api';

export const ModalDownloadInvoices = () => {
  const [selected, setSelected] = useState([]);
  const [disableDownloadType, setDisableDownloadType] = useState([]);

  const { closeModal, Modal } = useModal();

  const {
    isLoadingPickupDetails,
    protocolToModal,
    setProtocolToModal,
    pickupIdToModal,
    setPickupIdToModal,
    modalMessage,
    invoiceListToDownload,
    setInvoiceListToDownload,
    downloadConfigToModal,
    setDownloadConfigToModal
  } = useContext(SearchMyCollectionsContext);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = [];
      invoiceListToDownload.forEach((value) => {
        if (
          !!value.storageUrl &&
          !disableDownloadType.includes(value.typeDocument)
        ) {
          newSelected.push(value.taxInvoiceId);
        }
      });
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (_, taxInvoiceId) => {
    const selectedIndex = selected.indexOf(taxInvoiceId);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, taxInvoiceId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const handleCloseModal = () => {
    setInvoiceListToDownload([]);
    setProtocolToModal('');
    setPickupIdToModal('');
    setDownloadConfigToModal({});
    closeModal();
  };

  const handleDownload = () => {
    if (
      selected.length === 0 ||
      (selected.length === 1 && selected[0] === null)
    ) {
      toast(
        <Toast
          title="Atenção!"
          content="Selecione ao menos uma nota para baixar."
          type="error"
        />,
        options
      );

      return;
    }

    const link = document.createElement('a');

    selected.forEach((taxInvoiceId) => {
      const indexFile = invoiceListToDownload.findIndex(
        (invoice) => invoice.taxInvoiceId === taxInvoiceId
      );

      const url = invoiceListToDownload[indexFile].storageUrl;

      api.get(url, { responseType: 'arraybuffer' }).then((response) => {
        const type = response.headers['content-type'];
        const urlSplit = url.split('?')[0].split('/');

        const name = urlSplit[urlSplit.length - 1];

        const blob = new Blob([response.data], { type });

        link.href = URL.createObjectURL(blob);
        link.download = decodeURI(name);

        link.click();
      });
    });

    link.remove();

    handleCloseModal();
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  useEffect(() => {
    if (isLoadingPickupDetails === false) {
      const newDisableDownloadType = [];

      !downloadConfigToModal?.enableDanfeDownload &&
        newDisableDownloadType.push('PDF');

      !downloadConfigToModal?.enableXmlDownload &&
        newDisableDownloadType.push('XML');

      setDisableDownloadType(newDisableDownloadType);
    }
  }, [isLoadingPickupDetails]);

  return (
    <Modal preventClose>
      <Stack spacing={2}>
        <ModalTitle>Notas fiscais</ModalTitle>

        <ModalText>Protocolo: {protocolToModal}</ModalText>

        <TableContainer component={Paper}>
          <Table stickyHeader size="small">
            <TableHead>
              <StyledTableRow>
                {invoiceListToDownload.length > 0 && (
                  <StyledTableCell padding="checkbox">
                    <Checkbox
                      color="secondary"
                      indeterminate={
                        selected.length > 0 &&
                        selected.length <
                          invoiceListToDownload?.filter(
                            (value) =>
                              !!value.storageUrl &&
                              !disableDownloadType.includes(value.typeDocument)
                          )?.length
                      }
                      checked={
                        invoiceListToDownload?.filter(
                          (value) =>
                            !!value.storageUrl &&
                            !disableDownloadType.includes(value.typeDocument)
                        )?.length > 0 &&
                        selected.length ===
                          invoiceListToDownload?.filter(
                            (value) =>
                              !!value.storageUrl &&
                              !disableDownloadType.includes(value.typeDocument)
                          )?.length
                      }
                      onChange={handleSelectAllClick}
                    />
                  </StyledTableCell>
                )}
                <StyledTableCell style={{ textAlign: 'center' }}>
                  Nota Fiscal
                </StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>
                  Data saída
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {invoiceListToDownload.length === 0 ? (
                <StyledTableRow>
                  <StyledTableCell
                    colSpan={3}
                    style={{ textAlign: 'center', color: '#888' }}
                  >
                    {modalMessage}
                  </StyledTableCell>
                </StyledTableRow>
              ) : (
                <>
                  {invoiceListToDownload
                    ?.filter((value) => !!value.storageUrl)
                    ?.sort((a, b) => {
                      if (a.number < b.number) {
                        return -1;
                      }
                      if (a.number > b.number) {
                        return 1;
                      }
                      return 0;
                    })
                    ?.map((row, index) => (
                      <StyledTableRow
                        // eslint-disable-next-line react/no-array-index-key
                        key={row.storageUrl}
                        onClick={(event) => {
                          if (disableDownloadType.includes(row.typeDocument)) {
                            return;
                          }
                          handleClick(event, row.taxInvoiceId);
                        }}
                        style={{
                          cursor: !disableDownloadType.includes(
                            row.typeDocument
                          )
                            ? 'pointer'
                            : 'default'
                        }}
                      >
                        <StyledTableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={isSelected(row.taxInvoiceId)}
                            inputProps={{
                              // eslint-disable-next-line prefer-template, prettier/prettier
                              'aria-labelledby': String('table-checkbox-' + index)
                            }}
                            disabled={disableDownloadType.includes(
                              row.typeDocument
                            )}
                          />
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>
                          {row.number ?? '-'}
                        </StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>
                          {row.dateIssue
                            ? format(new Date(row.dateIssue), 'dd/MM/yyyy')
                            : '-'}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32
          }}
        >
          <Button
            type="button"
            variant="contained"
            color="secondary"
            onClick={handleCloseModal}
          >
            Voltar
          </Button>
          <Button type="button" variant="contained" onClick={handleDownload}>
            Baixar
          </Button>
        </Box>
      </Stack>
    </Modal>
  );
};
